import { WidgetLazyLoader } from 'components/common/WidgetLazyLoader';
import { configuration } from 'config/constants';
import React, { FC } from 'react';

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-help-center': {
                    id?: string;
                    'sg-connect-support': string,
                    'application-id': string;
                };
            }
        }
    }
}

export const HelpCenter: FC = () => {
    return (
        <WidgetLazyLoader script={`${configuration.widgetCdnBaseUrl}/widgets/sgwt-help-center/v4/sgwt-help-center.js`}>
            <aside>
                <sgwt-help-center
                    id="sgwtSuperHelpCenter"
                    sg-connect-support="sg-connect-v2"
                    application-id="subscription"
                />
            </aside>
        </WidgetLazyLoader>
    );
};